<ng-container *ngIf="combinedBrowseLinks$ | async as links">
  <div
    class="provider-filter"
    *ngIf="
      links.specialities?.length ||
      links.insurances?.length ||
      links.cities?.length
    "
  >
    <div class="provider-container">
      <div class="img-conrainer">
        <img src="/assets/Illo-Frame.svg" />
      </div>
      <div class="body-text">
        <h2>Browse more therapists</h2>
        <p class="iris-mt-02">Find a therapist that fits your needs</p>
      </div>
    </div>

    <div class="search-by-type" *ngIf="links.specialities?.length > 0">
      <h3>Search by Specialty</h3>
      <ng-container *ngFor="let speciality of links.specialities">
        <a
          [href]="
            providerDirectoryUrl +
            '/' +
            uriPrefix.STATE + '-' + currentStateAbbrev?.toLocaleLowerCase() +
            '/' +
            uriPrefix.CITY + '-' + ((uriSafeCity$ | async) || emptyURIValue) +
            '/' +
            uriPrefix.SPECIALTY + '-' + speciality.uriSafeValue
          "
          target="_blank"
        >
          {{ speciality.value }}
        </a>
      </ng-container>
    </div>

    <div class="search-by-type" *ngIf="links.insurances?.length > 0">
      <h3>Search by Insurance</h3>
      <ng-container *ngFor="let insurance of links.insurances">
        <a
          class="subtitle"
          [href]="
            providerDirectoryUrl +
            '/' +
            uriPrefix.STATE + '-' + currentStateAbbrev?.toLocaleLowerCase() +
            '/' +
            uriPrefix.CITY + '-' + ((uriSafeCity$ | async) || emptyURIValue) +
            '/' +
            uriPrefix.INSURANCE + '-' + insurance.uriSafeValue
          "
          target="_blank"
        >
          {{ insurance.value }}
        </a>
      </ng-container>
    </div>

    <div class="search-by-type" *ngIf="links.cities?.length > 0">
      <h3>Search by City</h3>
      <ng-container *ngFor="let city of links.cities">
        <a
          class="subtitle"
          [href]="
            providerDirectoryUrl +
            '/' +
            uriPrefix.STATE + '-' + currentStateAbbrev?.toLocaleLowerCase() +
            '/' +
            uriPrefix.CITY + '-' + city.uriSafeValue
          "
          target="_blank"
        >
          {{ city.value }}
        </a>
      </ng-container>
    </div>
  </div>
</ng-container>
